import React, { lazy, Suspense } from 'react'
import { CircularProgress } from '@material-ui/core'
import ResiliaIconBlue from '../../Views/AppBar/AppLogoBlue'
const NearMeIcon = lazy(() => import('@material-ui/icons/NearMe'))
const SchoolIcon = lazy(() => import('@material-ui/icons/School'))
const CheckCircleIcon = lazy(() => import('@material-ui/icons/CheckCircle'))
const LaptopIcon = lazy(() => import('@material-ui/icons/Laptop'))
const EditIcon = lazy(() => import('@material-ui/icons/Edit'))
const FolderIcon = lazy(() => import('@material-ui/icons/Folder'))
const LibraryBooksIcon = lazy(() => import('@material-ui/icons/LibraryBooks'))
const GroupIcon = lazy(() => import('@material-ui/icons/Group'))
const MenuBookIcon = lazy(() => import('@material-ui/icons/MenuBook'))
const PieChartIcon = lazy(() => import('@material-ui/icons/PieChart'))

type Props = {
  icon: string
}

const Icon = ({ icon }: Props) => {
  switch (icon) {
    case 'CheckCircle':
      return <CheckCircleIcon />
    case 'Laptop':
      return <LaptopIcon />
    case 'Edit':
      return <EditIcon />
    case 'Folder':
      return <FolderIcon />
    case 'LibraryBooks':
      return <LibraryBooksIcon />
    case 'Group':
      return <GroupIcon />
    case 'MenuBook':
      return <MenuBookIcon />
    case 'PieChart':
      return <PieChartIcon />
    case 'SchoolIcon':
      return <SchoolIcon />
    case 'NearMe':
      return <NearMeIcon />
    case '':
      return null
    case 'Resilia':
      return <ResiliaIconBlue />
    default:
      return null
  }
}

const MaterialIconSong = ({ icon }: Props) => {
  return (
    <Suspense fallback={<CircularProgress size={34} />}>
      <Icon icon={icon} />
    </Suspense>
  )
}

export default MaterialIconSong
